import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-study-block-ui',
  templateUrl: './study-block-ui.component.html',
  styleUrls: ['./study-block-ui.component.css'],
})
export class StudyBlockUIComponent {
  @Input() blockThisUI = true;
}
